export default __webpack_public_path__ + "static/31-51140ea8cd3974ec96835244c854651c.jpg";